<template>
  <div style="height:100%" class="div_consult_apply">
    <BaseContainer style="height:100%" class="one_table">
      <TableMain name="one table" ref="ConsultQuoteApplyTable1" :fields="fields" :title="table_title.title1"
        :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
        :show_date_picker="true" :loading_width="60" :show_toolbar="false" :show_filter="true" date_picker_label="创建时间"
        :query_button_label="query_lable" :isBusy="isBusy" @on_query="on_query" :table_height_adjust="-12"
        :hb_table_class="'hb_table_cqea_class1'" @on_cell_button_click="on_cell_button_click">
        <template #query>
          <el-select v-model="QuotationType" placeholder="报价类型" size="small" style="width: 100px" clearable>
            <el-option label="大货报价" value="大货报价"></el-option>
            <el-option label="打样报价" value="打样报价"></el-option>
          </el-select>
          <el-input placeholder="报价申请编号" clearable size="small" class="ml-1" style="width: 10rem"
            v-model="sobj.QuotationTaskNum"></el-input>
          <el-input placeholder="物料编号" clearable size="small" class="ml-1" style="width: 10rem"
            v-model="sobj.ItemId"></el-input>
          <el-input placeholder="物料名称" clearable size="small" class="ml-1" style="width: 11rem"
            v-model="sobj.NameAlias"></el-input>
          <el-input placeholder="供应商编号" clearable size="small" class="ml-1" style="width: 10rem"
            v-model="sobj.AccountNum"></el-input>
          <el-input placeholder="供应商名称" clearable size="small" class="ml-1" style="width: 11rem"
            v-model="sobj.AccountName"></el-input>
        </template>
      </TableMain>
    </BaseContainer>
    <!-- 附件 -->
    <el-dialog title="附件管理" :visible.sync="accessoryVisible" width="60%" :top="'5vh'" :close-on-click-modal="false"
      @opened="dialogOpened">
      <FileUpload ref="refAccessory" :accessoryCategory="'ConsultQuote'" :showUpload="false"
        @setAccessory="setAccessory">
      </FileUpload>
    </el-dialog>
    <!-- 供应商附件管理 -->
    <el-dialog title="供应商附件列表" :visible.sync="accessoryVendVisible" width="60%" :top="'5vh'"
      :close-on-click-modal="false" @opened="bottomDialogOpened">
      <FileUpload ref="refVendAccessory" :accessoryCategory="'ConsultQuoteVend'" :showUpload="false"
        @setAccessory="bottomSetAccessory">
      </FileUpload>
    </el-dialog>
  </div>
</template>

<script>
import * as ConsultQuoteConttroller from "../../controllers/mm/ConsultQuoteConttroller"
import FileUpload from "../FileUpload.vue"
import BaseContainer from "../components/BaseContainer"
import TableMain from "../components/table/TableMain"

export default {
  components: {
    BaseContainer,
    TableMain,
    FileUpload
  },
  data() {
    return {
      date_picker_label: "",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_consult_quote_vend_price",
      },
      fields: _.cloneDeep(ConsultQuoteConttroller.fields.consult_handle_fields),
      isBusy: false,
      sobj: {
        ItemId: "",
        NameAlias: "",
        AccountNum: "",
        AccountName: "",
        QuotationTaskNum: ""
      },
      current_accessory: null, ///当前派单选中附件
      accessoryVisible: false,
      current_vend_accessory: null,///当前供应商选中附件
      accessoryVendVisible: false,
      query_date: [],
      QuotationType: ""
    }
  },
  created() {
    // this.fields = _.filter(this.fields, (t) => { return t.key != "Accessory"; })
  },
  mounted() { },
  methods: {
    async on_query(set_data, _date, isLoading = true) {
      if (isLoading) {
        this.isBusy = true
        set_data([])
      }

      let p = {}
      for (var key in this.sobj) {
        if (this.sobj[key] != "") {
          this.sobj[key] = _.trim(this.sobj[key])
          if (key == "NameAlias" || key == "AccountName")
            p[key] = "%" + this.sobj[key] + "%"
          else
            p[key] = this.sobj[key]
        }
      }
      if (_.isEmpty(p) && _date && _date.length > 0) {
        this.query_date = _date
        let _fromDate = this.$date.format(_date[0], "yyyy-MM-dd")
        let _toDate = this.$date.format(_date[1], "yyyy-MM-dd")
        p["date_start"] = _fromDate
        p["date_end"] = _toDate
      }

      let _result = await ConsultQuoteConttroller.methods.getDataVendQuoteFromConsult(p)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let dt = _.orderBy(_result[0], ["id"], ["desc"])
        if (this.QuotationType !== "")
          dt = _.filter(dt, (t) => t.quotationType == this.QuotationType)
        _.each(dt, (t) => {
          t.AccessoryCount = 0
          t.AccessoryVendCount = 0
          if (t.Accessory && t.Accessory != "")
            t.AccessoryCount = JSON.parse(t.Accessory).length
          if (t.VendAccessory && t.VendAccessory != "")
            t.AccessoryVendCount = JSON.parse(t.VendAccessory).length
        })
        set_data(dt)
      }
      this.isBusy = false
    },
    //#region 附件
    async on_cell_button_click(data) {
      this.current_accessory = data.item
      this.current_vend_accessory = data.item
      if (data.field.key == "Accessory") this.accessoryVisible = true
      else if (data.field.key == "VendAccessory") this.accessoryVendVisible = true
    },
    dialogOpened() {
      this.$refs.refAccessory.getAccessory(this.current_accessory.Accessory, this.current_accessory.ItemId)
    },
    async dialogClosed() {
      if (this.current_accessory && this.current_accessory.Accessory) {
        let m = { id: this.current_accessory.id, Accessory: this.current_accessory.Accessory }, ml = []
        if (m.id && m.id != "") ml.push(m)
        this.current_accessory.AccessoryCount = JSON.parse(this.current_accessory.Accessory).length
        await ConsultQuoteConttroller.methods.saveDataDetailApply({ edit: ml })
      }
    },
    async setAccessory(data) {
      this.current_accessory.Accessory = data
      await this.dialogClosed()
    },
    //#endregion
    //#region 供应商附件
    bottomDialogOpened() {
      this.$refs.refVendAccessory.getAccessory(this.current_vend_accessory.VendAccessory, this.current_vend_accessory.ItemId)
    },
    bottomSetAccessory(data) {
      this.current_vend_accessory.Accessory = data
    }
    //#endregion
  },
}
</script>
<style>
.hb_table_cqea_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 250rem;
}

.div_consult_apply {}

.div_consult_apply .el-drawer__header {
  font-size: 1.1rem;
  /* color: black; */
}
</style>
